/**
 * Normalize Stripe Connect status for admin + vendor UI badges.
 *
 * @param {object|null|undefined} connect
 * @returns {{
 * key: string,
 * label: string,
 * className: string,
 * payoutReady: boolean,
 * accountId: string|null,
 * }}
 */
export function getStripeConnectStatus(connect) {
 const accountId = connect?.account_id || null;
 const payoutReady = Boolean(connect?.is_payout_ready);
 const raw = String(connect?.onboarding_status || (accountId ? 'pending' : 'not_started'))
 .toLowerCase()
 .replace(/\s+/g, '_');

 const pendingVerification = connect?.requirements?.pending_verification;
 const hasPendingVerification = Array.isArray(pendingVerification) && pendingVerification.length > 0;
 const caps = connect?.requirements?.capabilities || {};
 const capabilityPending = Object.values(caps).some((v) => v === 'pending');

 if (raw === 'in_review' || hasPendingVerification || capabilityPending) {
 return {
 key: 'in_review',
 label: 'In review',
 className: 'bg-sky-100 text-sky-800 border border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-800',
 payoutReady: false,
 accountId,
 };
 }

 if ((payoutReady || raw === 'complete') && raw !== 'restricted') {
 return {
 key: 'complete',
 label: 'Complete',
 className: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300',
 payoutReady: true,
 accountId,
 };
 }

 if (!accountId || raw === 'not_started') {
 return {
 key: 'not_started',
 label: 'Not started',
 className: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300',
 payoutReady: false,
 accountId: null,
 };
 }

 if (raw === 'restricted') {
 return {
 key: 'restricted',
 label: 'Restricted',
 className: 'bg-amber-100 text-amber-900 dark:bg-amber-950/40 dark:text-amber-300',
 payoutReady: false,
 accountId,
 };
 }

 return {
 key: 'pending',
 label: 'Pending',
      className: 'bg-surface-muted text-ink border border-border',
 payoutReady: false,
 accountId,
 };
}
